document.addEventListener('DOMContentLoaded', function () {
  const sideImages = document.querySelectorAll(
    '.hv2-hero .hv2-hero__side-images .i-image'
  );
  const sideIcons = document.querySelectorAll(
    '.hv2-hero .hv2-hero__side-images .i-icon'
  );
  const heroSection = document.querySelector('.hv2-hero');

  var animationTimeoutIds = [];
  var isAnimationPlaying = false;

  function hideElements(list) {
    list.forEach(function (image) {
      image.style.opacity = 0;
      image.style.animation = 'none';
      image.style.transition = 'opacity 1.5s ease';
    });
  }

  const slideFromLeftAnimation = 'slide-from-left 1s ease';
  const slideFromRightAnimation = 'slide-from-right 1s ease';
  const fadeInAnimation = 'fade-in 1s ease';
  const verticalLoop = 'loop-animation 3s linear infinite';

  function playAnimations() {
    hideElements(sideImages);

    let delayAnimate = 1000;

    const animations = [
      {
        element: sideImages[0],
        animation: slideFromLeftAnimation,
        delay: delayAnimate
      },
      {
        element: sideImages[1],
        animation: slideFromRightAnimation,
        delay: delayAnimate + 500
      },
      {
        element: sideImages[2],
        animation: slideFromRightAnimation,
        delay: delayAnimate + 1000
      },
      {
        element: sideImages[3],
        animation: slideFromLeftAnimation,
        delay: delayAnimate + 1500
      },
      {
        element: sideImages[4],
        animation: fadeInAnimation,
        delay: delayAnimate + 2000
      },
      {
        element: sideImages[5],
        animation: fadeInAnimation,
        delay: delayAnimate + 2500
      },
      {
        element: sideImages[6],
        animation: fadeInAnimation,
        delay: delayAnimate + 2500
      },
      {
        element: sideImages[7],
        animation: fadeInAnimation,
        delay: delayAnimate + 3000
      },
      {
        element: sideImages[8],
        animation: fadeInAnimation,
        delay: delayAnimate + 3500
      },
      {
        element: sideImages[9],
        animation: fadeInAnimation,
        delay: delayAnimate + 4000
      },
      {
        element: sideImages[10],
        animation: fadeInAnimation,
        delay: delayAnimate + 4500
      }
    ];

    animationTimeoutIds = [];

    playAnimationsLogic(animations, delayAnimate + 6000);
  }

  function playAnimationsLogic(animationList, delayStart) {
    let delay = delayStart;
    for (let i = 0; i < animationList.length; i++) {
      const { element, animation, delay } = animationList[i];
      const timeoutId = animateWithDelay(element, animation, delay);
      animationTimeoutIds.push(timeoutId);
    }

    animationTimeoutIds.push(
      setTimeout(function () {
        isAnimationPlaying = true;
        hideElements(sideIcons);
        playLoopAnimations();
      }, delay)
    );
  }

  function playLoopAnimations() {
    const animationsLoop = [
      { element: sideIcons[0], animation: verticalLoop },
      { element: sideIcons[1], animation: verticalLoop },
      { element: sideIcons[2], animation: verticalLoop },
      { element: sideIcons[3], animation: verticalLoop }
    ];

    for (let i = 0; i < animationsLoop.length; i++) {
      const { element, animation } = animationsLoop[i];
      element.style.animation = animation;
      element.style.opacity = 1;
    }
  }

  function animateWithDelay(element, animation, delayMs) {
    const animationTimeoutId = setTimeout(function () {
      element.style.animation = animation;
      element.style.opacity = 1;
    }, delayMs);

    return animationTimeoutId;
  }

  function isSectionVisible() {
    const rectHero = heroSection.getBoundingClientRect();
    const windowHeight =
      window.innerHeight || document.documentElement.clientHeight;

    return rectHero.top <= windowHeight && rectHero.bottom >= 0;
  }

  function handleScroll() {
    if (!isSectionVisible()) {
      isAnimationPlaying = false;
    }

    if (isSectionVisible() && !isAnimationPlaying) {
      isAnimationPlaying = true;
    }
  }

  function clearTimeouts() {
    animationTimeoutIds.forEach(function (timeoutId) {
      clearTimeout(timeoutId);
    });
  }

  function handleLoad() {
    if (isSectionVisible()) {
      clearTimeouts();
      isAnimationPlaying = true;
      playAnimations();
    }
  }
  handleLoad();
});
